import { fabric } from 'fabric'
import { centerObject } from '../tools/WorksSpace'
class Grid {
  /**
   * Creates an instance of Grid
   * @param {object} space l'espace entre chaque ligne
   * @param {object} lineConfig objet representant la configuration de la grille
   *  {stroke: '#ebebeb',
        strokeWidth: 1,
        selectable: false,
        opacity: 0.3,
        visible: true}
   * @memberof Grid
   */
  constructor(space, lineConfig) {
    this.visible = false
    this.lines = []
    this.space = space
    this.lineConfig = lineConfig
    this.canvas = null
    this._size = null
    this.marge = null
  }
  /**
   * initialise la construction de la grille
   *
   * @param {canvas} canvas objet fabric.Canvas
   * @param {object} size Objet représentant la taille et la position de la zone de travaille
   * @memberof Grid
   */
  draw(canvas, size) {
    if (this.linesGroup) {
      this.clear(canvas)
    }
    this.canvas = canvas
    this._size = size
    this.marge = { left: (canvas.width - size.width) / 2, top: (canvas.height - size.height) / 2 }
    this.__setVisibleLines(this.visible)
  }
  /**
   * efface tout les données sur les lignes de la grille
   *
   * @param {any} canvas
   * @memberof Grid
   */
  clear() {
    this.canvas.remove(this.linesGroup)
    this.lines = []
  }
  /**
   * affiche la grille
   *
   * @memberof Grid
   */
  show() {
    this.visible = true
    this.__setVisibleLines(this.visible)
  }
  /**
   * masque la grille
   *
   * @memberof Grid
   */
  hide() {
    this.visible = false
    this.__setVisibleLines(this.visible)
  }
  /**
   * affiche ou maseque la grille
   *
   * @memberof Grid
   */
  toggle() {
    this.visible = !this.visible
    this.__setVisibleLines(this.visible)
  }
  /**
   * methode privé pour rendre visible ou non les lignes de la grille
   * @param {Boolean} value
   * @private
   * @memberof Grid
   */
  __setVisibleLines(value) {
    if (value) {
      this.__createLines(this.canvas, this._size)
    } else {
      this.clear()
    }
  }
  /**
   * créé l'ensemble des lignes
   *
   * @param {canvas} canvas Objet fabric.canvas
   * @param {object} size Objet représentant la taille et la position de la zone de travaille
   * @private
   * @memberof Grid
   */
  __createLines(canvas, size) {
    for (let i = 0; i <= size.width; i += this.space) {
      this.lines = this.__addLines(i, 0, i, size.height)
    }
    for (let j = 0; j <= size.height; j += this.space) {
      this.lines = this.__addLines(0, j, size.width, j)
    }
    this.linesGroup = new fabric.Group(this.lines, {
      selectable: false,
      evented: false
    })
    this.linesGroup.excludeFromExport = true
    canvas.add(this.linesGroup)
    centerObject(this.canvas, this.linesGroup)
    canvas.bringToFront(this.linesGroup)
  }
  /**
   * met la grille au dessus de tout autre element du canvas (appeler par la command AddCommand)
   * verifie si il y'a un logo, dans ce cas on met le logo en premier plan et ensuite on met la grille par dessus
   *
   * @param {any} canvas
   * @memberof Grid
   */
  updateLayer(editor) {
    if (editor.logo) {
      editor.canvas.bringToFront(editor.logo)
    }
    editor.canvas.bringToFront(this.linesGroup)
  }
  /**
   * déplace la grille
   *
   * @param {any} posX
   * @param {any} posY
   * @memberof Grid
   */
  center(ws) {
    if (this.linesGroup) {
      centerObject(this.canvas, this.linesGroup)
    }
  }
  /**
   * magnetise l'element sur la grille
   *
   * @param {any} size
   * @param {any} event
   * @method
   */
  snaptToGrid(event) {
    if (this._valueIsSnaping(event.target.left) && this._valueIsSnaping(event.target.top)) {
      event.target
        .set({
          left: this._convertSnapPosition(event.target.left, this.marge.left),
          top: this._convertSnapPosition(event.target.top, this.marge.top)
        })
        .setCoords()
    }
  }

  /**
   * ajoute une ligne
   *@private
   * @memberof Grid
   */
  __addLines(startX, startY, endX, endY) {
    const line = new fabric.Line([startX, startY, endX, endY], this.lineConfig)
    return [...this.lines, line]
  }

  /**
   * Supprime la grille
   */
  clear() {
    this.canvas.remove(this.linesGroup)
    this.linesGroup = null
    this.lines = []
    this.canvas.requestRenderAll()
  }

  get size() {
    const left = this.linesGroup ? this.linesGroup.left : 0
    const top = this.linesGroup ? this.linesGroup.top : 0
    const width = this.linesGroup ? this.linesGroup.width : 0
    const height = this.linesGroup ? this.linesGroup.height : 0
    return {
      left,
      top,
      width,
      height
    }
  }
  /**
   * Test si la valeur est proche d'une ligne ou non
   * @param {*} value
   * @returns
   */
  _valueIsSnaping(value) {
    return Math.round(value % this.space) < this.space
  }
  _convertSnapPosition(value, marge) {
    return Math.round(value / this.space) * this.space + (marge % this.space)
  }
}

export default Grid



// WEBPACK FOOTER //
// ./src/model/pixel/elements/Grid.js